import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { UnifiedRoutingContactOwnerExplainer } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingContactOwnerExplainer';
import { UnifiedRoutingUsersAndTeamsExplainer } from 'automation-ui-action-features/actions/rotate-object/UnifiedRoutingUsersAndTeamsExplainer';
import { checkIsUnassigned, getRoutingRules } from 'automation-ui-action-features/actions/rotate-object/utils/routing-rules';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { checkCanHaveFallback } from 'routing-ui/routing-rules/operators/routingRulesGetters';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnifiedRoutingActionExplainer = ({
  metadata,
  objectTypeId
}) => {
  const routingRuleDefinition = getRoutingRules(metadata);
  if (checkIsUnassigned(routingRuleDefinition)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        ObjectTypeName
      },
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.explainer.no-one_jsx",
      options: {
        objectTypeId
      }
    });
  }
  const ExplainerComponent = checkCanHaveFallback(routingRuleDefinition) ? UnifiedRoutingContactOwnerExplainer : UnifiedRoutingUsersAndTeamsExplainer;
  return /*#__PURE__*/_jsx(ExplainerComponent, {
    objectTypeId: objectTypeId,
    routingRuleDefinition: routingRuleDefinition
  });
};
UnifiedRoutingActionExplainer.displayName = 'UnifiedRoutingActionExplainer';